import { fromNow } from "@common/utils/localTime.utils";
import { TFunction } from "i18next";

export const getLocationStatusSchedule = (
  t: TFunction,
  open?: boolean,
  statusUntil?: number
): string | undefined => {
  if (!open && !statusUntil) return t("Always closed");
  if (open && !statusUntil) return t("Always open");

  if (statusUntil) {
    const locationTime = t(...fromNow(statusUntil, true, true, true));

    return open
      ? `${t("Location Closes in :")} ${locationTime}`
      : `${t("Location Opens in :")} ${locationTime}`;
  }

  return undefined;
};
